import { render, staticRenderFns } from "./organism.modal.shareYourDesign.vue?vue&type=template&id=7aed7d9b"
import script from "./organism.modal.shareYourDesign.vue?vue&type=script&lang=ts"
export * from "./organism.modal.shareYourDesign.vue?vue&type=script&lang=ts"
import style0 from "./organism.modal.shareYourDesign.vue?vue&type=style&index=0&id=7aed7d9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports